import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgMessageDots = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M3 5.983C3 4.888 3.895 4 5 4h14c1.105 0 2 .888 2 1.983v8.923a1.99 1.99 0 0 1-2 1.983h-6.6l-2.867 2.7c-.955.899-2.533.228-2.533-1.08v-1.62H5c-1.105 0-2-.888-2-1.983zm5.706 3.809a1 1 0 1 0-1.412 1.417 1 1 0 1 0 1.412-1.417m2.585.002a1 1 0 1 1 .003 1.414 1 1 0 0 1-.003-1.414m5.415-.002a1 1 0 1 0-1.412 1.417 1 1 0 1 0 1.412-1.417",
    clipRule: "evenodd"
  }
) }));

export { SvgMessageDots as default };
//# sourceMappingURL=message-dots.mjs.map
